import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    reorderUrl: String,
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-handle]",
      filter: "tr:not([data-production-track-id]), tr[data-status='O']",
      preventOnFilter: true,
      ghostClass: "ghost",
      dragClass: "drag",
      animation: 150,
      onMove: this.onMove.bind(this),
      onEnd: this.onEnd.bind(this),
    })
  }

  onMove(evt) {
    const rows = Array.from(this.element.querySelectorAll("tr[data-production-track-id]"))
    const firstNonOpenIndex = rows.findIndex((row) => row.dataset.status !== "O")
    if (firstNonOpenIndex < 0) return true

    const relatedIndex = rows.indexOf(evt.related)
    if (relatedIndex < 0) return true

    const newIndex = evt.willInsertAfter ? relatedIndex + 1 : relatedIndex
    if (newIndex < firstNonOpenIndex) return false

    return true
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  updatePriCells() {
    const rows = this.element.querySelectorAll("tr[data-production-track-id]")
    rows.forEach((row, index) => {
      row.cells[0].textContent = index + 1
    })
  }

  onEnd() {
    this.updatePriCells()

    const ids = Array.from(this.element.querySelectorAll("tr[data-production-track-id]"))
      .map((row) => row.dataset.productionTrackId)
      .filter(Boolean)

    if (ids.length === 0) return

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]')?.content,
        Accept: "application/json",
      },
      body: JSON.stringify({ order: ids }),
    }).then((response) => {
      if (!response.ok) {
        window.toast?.("Failed to save order", "error")
      }
    })
  }
}
